module.exports = __webpack_public_path__ + "img/tab-baseinfo.82609dd0.png";